<template>
  <div class="content-wrapper place-order-wrapper relative">
    <div
      v-if="deliverCostInProgress"
      class="loading-overlay">
      <div class="loader">
        <span>Indlæsning af data&hellip;</span>
      </div>
    </div>
    <div class="wrapper place-order">
      <validation-observer
        ref="place-order-form"
        tag="form"
        class="columns-wrapper mt-1">

        <div class="column column-left">

          <h2 class="mt-0 mb-1">Faktureringsadresse</h2>

          <div class="form-group">
            <validation-provider
              name="name"
              rules="required"
              class="full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="name"
                class="order-form-label">
                <span class="input-name">Navn</span>
                <c-input
                  type="text"
                  v-model="data.name"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <validation-provider
              name="email"
              rules="required|email"
              class="full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="email"
                class="order-form-label">
                <span class="input-name">Email</span>
                <c-input
                  type="text"
                  v-model="data.email"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          <!-- </div>

          <div class="form-group"> -->
            <validation-provider
              name="phone"
              rules="required"
              class="ml-2 ml-md-0 full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="phone"
                class="order-form-label">
                <span class="input-name">Telefon</span>
                <c-input
                  type="text"
                  v-model="data.phone"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <validation-provider
              name="address-1"
              rules="required"
              class="full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="address-1"
                class="order-form-label">
                <span class="input-name">Adresse</span>
                <c-input
                  type="text"
                  v-model="data.address_1"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          <!-- </div>

          <div class="form-group"> -->
            <validation-provider
              name="address-2"
              rules=""
              class="ml-2 ml-md-0 full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="address-2"
                class="order-form-label">
                <span class="input-name">Adresse fortsat</span>
                <c-input
                  type="text"
                  v-model="data.address_2"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <validation-provider
              name="postcode"
              rules="required"
              class="full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="postcode"
                class="order-form-label">
                <span class="input-name">Postnr</span>
                <c-input
                  type="text"
                  v-model="data.postcode"
                  :state="errors.length ? 'invalid' : null"
                  @change="handlePostCodeChange"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          <!-- </div>

          <div class="form-group"> -->
            <validation-provider
              name="city"
              rules="required"
              class="ml-2 ml-md-0 full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="city"
                class="order-form-label">
                <span class="input-name">By</span>
                <c-input
                  type="text"
                  v-model="data.city"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <validation-provider
              name="country"
              rules="required"
              class="full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="country"
                class="order-form-label">
                <span class="input-name">Land</span>
                <c-input
                  type="text"
                  v-model="data.country"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </div>

        <div class="column column-right">
          <h2 class="mt-0 mb-1">Leveringsadresse</h2>

          <div class="form-group mb-1">
            <validation-provider
              name="same_delivery-address"
              rules="required"
              class="mt-1"
              v-slot="{ errors }">

              <c-checkbox
                :is-small="true"
                v-model="data.same_delivery_address"
                :state="errors.length ? 'invalid' : null">
                Samme adresse som leveringsadressen
              </c-checkbox>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <validation-provider
              name="delivery-name"
              :rules="data.same_delivery_address ? '' : 'required'"
              class="full-width"
              v-slot="{ errors }">
              <label
                for="delivery-name"
                :class="{
                  'order-form-label': true,
                  'is-disabled': data.same_delivery_address
                }">
                <span class="input-name">Navn</span>
                <c-input
                  type="text"
                  v-model="data.delivery_name"
                  :disabled="data.same_delivery_address"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <validation-provider
              name="delivery-email"
              :rules="data.same_delivery_address ? '' : 'required|email'"
              class="full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="delivery-email"
                :class="{
                  'order-form-label': true,
                  'is-disabled': data.same_delivery_address
                }">
                <span class="input-name">Email</span>
                <c-input
                  type="text"
                  v-model="data.delivery_email"
                  :disabled="data.same_delivery_address"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          <!-- </div>

          <div class="form-group"> -->
            <validation-provider
              name="delivery-phone"
              :rules="data.same_delivery_address ? '' : 'required'"
              class="ml-2 ml-md-0 full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="delivery-phone"
                :class="{
                  'order-form-label': true,
                  'is-disabled': data.same_delivery_address
                }">
                <span class="input-name">Telefon</span>
                <c-input
                  type="text"
                  v-model="data.delivery_phone"
                  :disabled="data.same_delivery_address"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <validation-provider
              name="delivery-address-1"
              :rules="data.same_delivery_address ? '' : 'required'"
              class="full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="delivery-address-1"
                :class="{
                  'order-form-label': true,
                  'is-disabled': data.same_delivery_address
                }">
                <span class="input-name">Adresse</span>
                <c-input
                  type="text"
                  v-model="data.delivery_address_1"
                  :disabled="data.same_delivery_address"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          <!-- </div>

          <div class="form-group"> -->
            <validation-provider
              name="delivery-address-2"
              rules=""
              class="ml-2 ml-md-0 full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="delivery-address-2"
                :class="{
                  'order-form-label': true,
                  'is-disabled': data.same_delivery_address
                }">
                <span class="input-name">Adresse fortsat</span>
                <c-input
                  type="text"
                  v-model="data.delivery_address_2"
                  :disabled="data.same_delivery_address"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <validation-provider
              name="delivery-postcode"
              :rules="data.same_delivery_address ? '' : 'required'"
              class="full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="delivery-postcode"
                :class="{
                  'order-form-label': true,
                  'is-disabled': data.same_delivery_address
                }">
                <span class="input-name">Postnr</span>
                <c-input
                  type="text"
                  v-model="data.delivery_postcode"
                  :disabled="data.same_delivery_address"
                  :state="errors.length ? 'invalid' : null"
                  @change="fetchDeliveryCost"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          <!-- </div>

          <div class="form-group"> -->
            <validation-provider
              name="delivery-city"
              :rules="data.same_delivery_address ? '' : 'required'"
              class="ml-2 ml-md-0 full-width order-form-field"
              v-slot="{ errors }">
              <label
                for="delivery-city"
                :class="{
                  'order-form-label': true,
                  'is-disabled': data.same_delivery_address
                }">
                <span class="input-name">By</span>
                <c-input
                  type="text"
                  v-model="data.delivery_city"
                  :disabled="data.same_delivery_address"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <validation-provider
              name="delivery-country"
              :rules="data.same_delivery_address ? '' : 'required'"
              class="full-width"
              v-slot="{ errors }">
              <label
                for="delivery-country"
                :class="{
                  'order-form-label': true,
                  'is-disabled': data.same_delivery_address
                }">
                <span class="input-name">Land</span>
                <c-input
                  type="text"
                  v-model="data.delivery_country"
                  :disabled="data.same_delivery_address"
                  :state="errors.length ? 'invalid' : null"/>
              </label>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <validation-provider
            tag="div"
            name="shipment-method"
            rules="required"
            class="form-group flex-wrap delivery-method-wrapper mb-0"
            v-slot="{ errors }">
            <span class="input-name full-width block">Leveringsmetode</span>

            <c-form-radio
              v-for="method in optionsShipmentMethods"
              :key="'method-' + method.id"
              :value="method.id"
              v-model="data.shipment_method"
              class="text-center delivery-method-item"
              :state="errors.length ? 'invalid' : null">
              <span class="c-form-radio-label">
                <strong>{{ method.name }}</strong>
                {{ getShippingPriceForDisplay(method) }}
              </span>
            </c-form-radio>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>

        <div class="column full-width">
          <hr class="my-2">

          <div class="form-group">
            <validation-provider
              name="terms-and-conditions"
              rules="required|is-checked"
              v-slot="{ errors }">

              <c-checkbox
                :is-small="true"
                v-model="terms_and_conditions"
                :state="errors.length ? 'invalid' : null">
                Jeg har læst og accepterer <a href="documents/terms_and_conditions.pdf" target="_blank" rel="nofollow noopener noreferrer">handelsbetingelserne</a>
              </c-checkbox>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <hr class="my-2">

          <div class="flex mb-1">
            <strong class="mr-2">Produktets pris</strong>
            <span
              v-if="cartTotalPriceBeforeDiscount"
              class="total-price-discount ml-auto mr-2">
              {{ getPriceFormatted(cartTotalPriceBeforeDiscount) }}
            </span>
            <span
              :class="{
                'total-price': true,
                'ml-auto': !cartTotalPriceBeforeDiscount
              }">
              {{ getPriceFormatted(cartTotalPrice) }}
            </span>
          </div>
          <div class="flex mb-0">
            <strong class="mr-2">Levering</strong>
            <span class="ml-auto">{{ getPriceFormatted(selectedShipmentMethodPrice) }}</span>
          </div>

          <hr class="my-2">

          <div class="flex mb-4">
            <strong class="mr-2">Total pris</strong>
            <strong class="total-price ml-auto">
              {{ getPriceFormatted(orderTotalPrice) }}
            </strong>
          </div>
        </div>

      </validation-observer>
      <template v-if="submitInProgress">
        <div class="loading-overlay">
          <div class="loader">
            <span>Databehandling er i gang&hellip;</span>
          </div>
        </div>
      </template>
    </div>
    <div class="navigation-buttons flex mt-auto">
      <c-button
        :theme="'secondary'"
        class="mr-auto"
        :disabled="deliverCostInProgress"
        @click.prevent="goBack">
        Tilbage
      </c-button>
      <c-button
        :theme="'primary'"
        class="ml-auto"
        :disabled="deliverCostInProgress"
        @click.prevent="validateForm">
        Bestil
      </c-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import FormUtils from '@/utils/FormUtils.js';
import CustomDecimals from '@/utils/CustomDecimals.js';
import fetchPriceMixin from '@/mixins/fetchPriceMixin';

export default {
  name: 'place-order',
  mixins: [fetchPriceMixin],
  computed: {
    ...mapGetters('cart', [
      'wardrobeList',
      'cartTotalPrice',
      'cartTotalPriceBeforeDiscount'
    ]),
    ...mapGetters('apiData', [
      'optionsShipmentMethods'
    ]),
    selectedShipmentMethodPrice () {
      if (!this.data.shipment_method) {
        return 0;
      }

      let selectedShipment = this.optionsShipmentMethods.find(item => item.id === this.data.shipment_method);
      if (!selectedShipment || !selectedShipment.price || selectedShipment.price <= 0) {
        return 0;
      }

      if (this.shippingPriceFromApi) {
        return this.shippingPriceFromApi;
      }

      return selectedShipment.price;
    },
    orderTotalPrice () {
      return this.cartTotalPrice + this.selectedShipmentMethodPrice;
    }
  },
  watch: {
    'data.same_delivery_address': function() {
      this.fetchDeliveryCost();
    }
  },
  data () {
    return {
      data: {
        name: '',
        email: '',
        phone: '',
        address_1: '',
        address_2: '',
        postcode: '',
        city: '',
        country: '',
        same_delivery_address: false,
        delivery_name: '',
        delivery_email: '',
        delivery_phone: '',
        delivery_address_1: '',
        delivery_address_2: '',
        delivery_postcode: '',
        delivery_city: '',
        delivery_country: '',
        shipment_method: null
      },
      shippingPriceFromApi: null,
      terms_and_conditions: false,
      submitInProgress: false,
      deliverCostInProgress: false
    }
  },
  mounted () {
    this.data = JSON.parse(JSON.stringify(this.$store.getters['invoice/invoiceData']));

    this.fetchDeliveryCost();
  },
  methods: {
    validateForm () {
      console.log(this.prepareFormDataToSend());
      FormUtils.validate(this.$refs['place-order-form'], this.submitForm, this.scrollToInvalid);
    },
    scrollToInvalid () {
      this.$el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
    },
    submitForm () {
      this.submitInProgress = true;
      this.$store.commit('invoice/setInvoiceData', this.data);

      let formDataToSend = this.prepareFormDataToSend();

      FormUtils.submitInBackground(this, {
        endpoint: '/api/order/store',
        params: formDataToSend,
        errorTitle: 'Der opstod en fejl',
        errorText: 'Det lykkedes ikke at indsende din bestilling. Kontroller din internetforbindelse og prøv igen.',
        successAction: (response) => {
          this.submitInProgress = false;
          if (response.payment && response.payment_url) {
            window.open(response.payment_url, '_self');
          } else {
            Vue.swal({
              title: 'Der opstod en fejl',
              html: 'Omdirigering til betalingsside mislykkedes. Prøv igen.',
              icon: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });
          }
        },
        failAction: () => {
          this.submitInProgress = false;
        }
      }, 'file');
    },
    prepareFormDataToSend () {
      let wardrobesForOrder = [];
      this.wardrobeList.forEach(item => {
        wardrobesForOrder.push(this.getWardrobeForOrder(item));
      })

      let output = {
        wardrobeList: wardrobesForOrder,
        name: this.data.name,
        email: this.data.email,
        phone: this.data.phone,
        address_1: this.data.address_1,
        address_2: this.data.address_2,
        postcode: this.data.postcode,
        city: this.data.city,
        country: this.data.country,
        same_delivery_address: this.data.same_delivery_address,
        delivery_name: this.data.same_delivery_address ? this.data.name : this.data.delivery_name,
        delivery_email: this.data.same_delivery_address ? this.data.email : this.data.delivery_email,
        delivery_phone: this.data.same_delivery_address ? this.data.phone : this.data.delivery_phone,
        delivery_address_1: this.data.same_delivery_address ? this.data.address_1 : this.data.delivery_address_1,
        delivery_address_2: this.data.same_delivery_address ? this.data.address_2 : this.data.delivery_address_2,
        delivery_postcode: this.data.same_delivery_address ? this.data.postcode : this.data.delivery_postcode,
        delivery_city: this.data.same_delivery_address ? this.data.city : this.data.delivery_city,
        delivery_country: this.data.same_delivery_address ? this.data.country : this.data.delivery_country,
        shipment_method: this.data.shipment_method,
        total_price: this.orderTotalPrice
      }

      return output;
    },
    goBack () {
      this.$store.commit('invoice/setInvoiceData', this.data);
      this.$router.push({ name: 'orderSummary' });
    },
    getPriceFormatted (price) {
      return CustomDecimals.getPriceFormatted(price);
    },
    getWardrobeForOrder (singleWardrobeData) {
      let inventoryFormatted = singleWardrobeData.inventory.map(item => ({
        inventory_id: item.id,
        height: item.height,
        width: item.width,
        x_position: item.posX,
        y_position: item.posY
      }));

      let wardrobeForOrder = JSON.parse(JSON.stringify(singleWardrobeData.wardrobe));
      console.log(singleWardrobeData)

      wardrobeForOrder.screenshot = singleWardrobeData.screenshots && singleWardrobeData.screenshots.front ? singleWardrobeData.screenshots.front : null;
      wardrobeForOrder.screenshot_bottom = singleWardrobeData.screenshots && singleWardrobeData.screenshots.top ? singleWardrobeData.screenshots.top : null;
      wardrobeForOrder.screenshot_doors = singleWardrobeData.screenshots && singleWardrobeData.screenshots.materials ? singleWardrobeData.screenshots.materials : null;

      wardrobeForOrder.gable_id = wardrobeForOrder.gable_id || 0;
      wardrobeForOrder.gable_filling_id = wardrobeForOrder.gable_filling_id || 0;
      wardrobeForOrder.impact_filling_id = wardrobeForOrder.impact_filling_id || 0;

      return {
        wardrobe: wardrobeForOrder,
        doors: JSON.parse(JSON.stringify(singleWardrobeData.doors)),
        inventory: inventoryFormatted,
        price: JSON.parse(JSON.stringify(singleWardrobeData.price))
      }
    },
    fetchDeliveryCost () {
      this.deliverCostInProgress = true;

      FormUtils.submitInBackground(this, {
        endpoint: '/api/delivery/price',
        params: {
          number_wardrobes: this.wardrobeList.length,
          post_code: this.data.same_delivery_address ? this.data.postcode : this.data.delivery_postcode
        },
        successAction: (response) => {
          if (response.data && response.data.delivery_price) {
            this.shippingPriceFromApi = response.data.delivery_price;
          } else {
            this.shippingPriceFromApi = null;
          }
          this.deliverCostInProgress = false;
        },
        failAction: () => {
          this.shippingPriceFromApi = null;
          this.deliverCostInProgress = false;
        }
      }, 'file');
    },
    handlePostCodeChange () {
      if (this.data.same_delivery_address) {
        this.fetchDeliveryCost();
      }
    },
    getShippingPriceForDisplay (shippingMethod) {
      // Two delivery methods come from API: one free and one with price. Here we show calculated delivery price for the one that is not free
      if (!shippingMethod.price || shippingMethod.price <= 0) {
        return this.getPriceFormatted(shippingMethod.price);
      }

      if (this.shippingPriceFromApi) {
        return this.getPriceFormatted(this.shippingPriceFromApi);
      }

      return this.getPriceFormatted(shippingMethod.price);
    }
  }
}
</script>
